import React from "react";
import { ApplicationType } from "csv-package";

import api from "../helpers/api";
import { isAuthenticated, getUsername } from "../helpers/auth";

import LoadingIndicator from "../components/LoadingIndicator";
import { useHistory } from "react-router-dom";
import {
  configApplicationType,
  configJurisdiction,
} from "../config/systemConfig";

type ApplicationCreateProps = {
  infoShare?: string;
};

const ApplicationCreate: React.FC<ApplicationCreateProps> = ({ infoShare }) => {
  const { replace } = useHistory();

  React.useEffect(() => {
    const createApplication = async () => {
      try {
        const isAuth = await isAuthenticated();
        if (!isAuth) {
          replace(`/signup`);
        }
        const Username = await getUsername();
        const Type = configApplicationType;
        const Jurisdiction = configJurisdiction;

        const result = (await api("post", "/public/application", {
          Username,
          Type,
          Jurisdiction,
          Data: {
            appl_info_share: infoShare
          }
        })) as ApplicationType;

        if (typeof result.ApplicationID !== "string") {
          throw new Error("Application failed to create");
        }

        let url = `/application/${result.ApplicationID}`;
        replace(url);
      } catch (e: any) {
        console.error(e);
        console.log("error creating new application");
      }
    };
    createApplication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingIndicator />;
};

export default ApplicationCreate;
